


















































import Vue, { PropType } from "vue";
import { InputValidationRules } from "vuetify";

const isoRegex = /^([0-9]{4})-([0-9]{2})-([0-9]{2})$/;
const localRegex = /^([0-9]{1,2})[./-]([0-9]{1,2})[./-]([0-9]{4}$)/;

export default Vue.extend({
  props: {
    value: {
      type: [String, Date],
    },
    label: String,
    hint: String,
    readonly: Boolean,
    disabled: Boolean,
    persistentHint: Boolean,
    rules: {
      type: Array as PropType<InputValidationRules>,
      default: () => [] as InputValidationRules,
    },
  },
  inject: {
    form: { default: null },
  },
  data() {
    return {
      date: "",
      dateModel: false,
      formattedDate: "",
      showDatePicker: false,
      errorMessages: [] as string[],
      lastKeyCode: 0,
    };
  },
  computed: {
    shouldValidate(): boolean {
      return !this.readonly && !this.disabled;
    },
    hasError(): boolean {
      return !!this.errorMessages.length;
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(newValue) {
        if (newValue != null) {
          if (typeof newValue == "object") {
            newValue = (newValue as Date).toISOString().slice(0, -14);
            this.dateModel = true;
          }
          //if string format with Timezone
          if (newValue.length > 10) {
            newValue = newValue.slice(0, 10);
          }
          this.date = newValue;
          this.formattedDate = this.date && this.date.replace(isoRegex, "$3/$2/$1");
        }
      },
    },
  },
  methods: {
    validate(force?: boolean): boolean {
      if (force) {
        this.onTextInput(this.formattedDate);
      }
      return this.hasError;
    },
    reset() {},
    resetValidation() {
      this.errorMessages = [];
    },
    onFocus() {
      this.lastKeyCode = 0;
    },
    onBlur() {
      if (this.lastKeyCode === 9) {
        this.showDatePicker = false;
      }
      this.validate(true);
    },
    onKeyDown(e: KeyboardEvent) {
      const key = e.charCode || e.keyCode || 0;
      this.lastKeyCode = key;
      if (key == 13) {
        this.showDatePicker = !this.showDatePicker;
        return;
      }

      if (!this.isKeyAllowed(key)) {
        e.preventDefault();
      }
    },
    onTextInput(value: string) {
      value = (value || "").trim();
      const match = value.match(localRegex);

      this.errorMessages = [];

      if (match) {
        const d = parseInt(match[1]);
        const m = parseInt(match[2]);
        const y = parseInt(match[3]);

        if (y === 0) {
          this.errorMessages = [this.$i18n.t("validation.date").toString()];
          return;
        } else if (m == 0 || m > 12) {
          this.errorMessages = [this.$i18n.t("validation.date").toString()];
          return;
        }
        const maxDay = new Date(y, m, 0).getDate();

        if (d > maxDay) {
          this.errorMessages = [this.$i18n.t("validation.date").toString()];
          return;
        }

        const dateValueToEmit = `${match[3]}-${match[2].padStart(2, "0")}-${match[1].padStart(2, "0")}`;

        this.applyRules(dateValueToEmit);

        if (!this.hasError) {
          this.$emit("input", this.dateModel ? new Date(dateValueToEmit) : dateValueToEmit);
        }
      } else {
        if (value) {
          this.errorMessages = [this.$i18n.t("validation.date").toString()];
        }
        this.applyRules(value);
      }
    },
    onDatePickerInput(value: string) {
      this.errorMessages = [];
      this.applyRules(value);
      if (!this.hasError) {
        this.showDatePicker = false;
        this.$emit("input", this.dateModel ? new Date(value) : value);
      }
    },
    applyRules(value: string) {
      for (let index = 0; index < this.rules.length; index++) {
        const rule = this.rules[index];
        const valid = typeof rule === "function" ? rule(value) : rule;

        if (valid !== true) {
          this.errorMessages.push(valid.toString());
        }
      }
    },
    isKeyAllowed(key: number): boolean {
      return (
        key == 8 || // bs
        key == 9 || // tab
        key == 13 || // enter
        key == 46 || // del
        key == 110 || // period
        key == 189 || // hyphen
        key == 190 || // numpad decimal
        key == 191 || // /
        key == 111 || // /
        (key >= 48 && key <= 57) || // 0-9
        (key >= 96 && key <= 105) // 0-9 numpad
      );
    },
  },
  created() {
    const frm = (this as any).form;
    frm && frm.register(this);
  },
  beforeDestroy() {
    const frm = (this as any).form;
    frm && frm.unregister(this);
  },
});
